{
  "documentTitle": "Se connecter à Salt",
  "heading": "Bienvenue dans Salt",
  "instructions": "Téléchargez l'application Salt, puis appuyez à nouveau sur le « Magic Link » figurant dans l'e-mail pour vous connecter.",
  "codeLabel": "Votre code de connexion"
}
